import React from 'react';
import './admin-sidebar.styles.scss'
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom'

const AdminSidebar = ({
  tabs
}) => {

  const screenSize = useSelector(state => state.listsData.screenSize);
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className={`admin_sidebar ${screenSize}`}>
      {
        (tabs && location) &&
        <div className='admin_sidebar_buttons g-card'>
          {
            tabs.map(tab => (
              <button
                key={tab.id}
                href={tab.href}
                className={`g-button med-btn ${location.pathname.includes(tab.href)
                    ? 'active'
                    : ''}`
                }
                onClick={() => navigate(tab.href)}
              >
                {tab.title}
              </button>
            ))
          }
        </div>
      }
    </div>
  )
}

export default AdminSidebar